// import type { SmartFitDuration } from "./smartFit.constants";

interface PaymentSummaryCardProps {
  planName?: string;
  holosMonthlyCharge: number;
  hasPromo: boolean;
  promoDiscount: number;
  // originalChargeToday: number;
  chargeToday: number;
  cycleDuration?: number;
  // isSmartFitSelected: boolean;
  // smartFitDuration: SmartFitDuration;
  // smartFitPrice: number;
  className?: string;
  selectedPaymentOption: 'today' | 'nextCycle';
}

const formatAmount = (amount: number) => Number.isInteger(amount) ? amount.toString() : amount.toFixed(2);

const getCycleLabel = (cycleDuration?: number) => {
  if (cycleDuration === 12) return 'año';
  if (cycleDuration === 3) return 'trimestre';
  return 'mes';
};

export const PaymentSummaryCard = ({
  planName,
  holosMonthlyCharge,
  hasPromo,
  promoDiscount,
  // originalChargeToday,
  chargeToday,
  cycleDuration,
  // isSmartFitSelected,
  // smartFitDuration,
  // smartFitPrice,
  selectedPaymentOption,
  className = "my-6 bg-holos-light border-1 border-gray-400 rounded-2xl p-4 text-sm text-gray-800",
}: PaymentSummaryCardProps) => {
  const isNextCycle = selectedPaymentOption === 'nextCycle';
  const cycleLabel = getCycleLabel(cycleDuration);
  return (
    <div className={className}>
      <div className="space-y-1">
        <div className="flex items-start justify-between gap-3">
          <div className="font-medium text-base">{planName}</div>
          <div className="font-semibold">S/. {formatAmount(holosMonthlyCharge)}/{cycleLabel}</div>
        </div>

        {hasPromo && <div className="flex items-start justify-between gap-3">
          <div>Descuento</div>
          <div className="font-semibold">-S/. {formatAmount(promoDiscount)}</div>
        </div>}

        {/* {isSmartFitSelected && (
          <div className="flex items-start justify-between gap-3 text-[15px]">
            <div>Smart Fit Black · {smartFitDuration} (unico)</div>
            <div className="font-semibold">S/. {formatAmount(smartFitPrice)}</div>
          </div>
        )} */}
      </div>

      <div className="my-3 border-t border-gray-400" />



      <div className="flex items-center justify-between gap-3 justify-items-center">
        <div>
          <div className="text-xl font-bold leading-none">
            Cargo {isNextCycle ? 'al final del ciclo' : 'hoy'}
          </div>
          <div className="mt-1 text-md text-gray-700">
            Plan Holos S/. {formatAmount(holosMonthlyCharge)} / {cycleLabel}
            {/* {isSmartFitSelected && !isNextCycle ? ` + Smart Fit S/. ${formatAmount(smartFitPrice)} (${smartFitDuration}, unico)` : ''} */}
          </div>
        </div>

        <div className="text-right">
          {/* {hasPromo && (
            <div className="text-sm text-gray-400 line-through">
              S/. {formatAmount(originalChargeToday - (isNextCycle && isSmartFitSelected ? smartFitPrice : 0))}
            </div>
          )} */}
          <div className="font-serif text-2xl font-semibold leading-none whitespace-nowrap">
            S/. {formatAmount(chargeToday /* - (isNextCycle && isSmartFitSelected ? smartFitPrice : 0) */)}
          </div>
        </div>
      </div>
      {/* {(isNextCycle && isSmartFitSelected) && <div className="flex items-center justify-between gap-3 justify-items-center">
        <div>
          <div className="text-xl font-bold leading-none">Cargo hoy</div>
          <div className="mt-1 text-md text-gray-700">
            + Smart Fit S/. {formatAmount(smartFitPrice)} ({smartFitDuration}, unico)
          </div>
        </div>

        <div className="text-right">
          <div className="font-serif text-2xl font-semibold leading-none whitespace-nowrap">
            S/. {formatAmount(smartFitPrice)}
          </div>
        </div>
      </div>} */}
    </div>
  );
};